import * as React from "react";
import Loader from "react-loader-spinner";

export class SpinnerInline extends React.Component {

    render() {
        return <Loader type="Bars" color="#F6BE00" height={80} width={80} />;
    }

};